import ImgClique from "../img/icon/correios.png";
import React, { useState } from "react";
import ModalAceite from "./modalaceite";
import IconInformative from "../componentsStyled/icon/iconinformative";
import { Box, Button, IconButton, Tooltip } from "@mui/material";

interface CorreiosProps {
  className?: string;
  onSelect: () => void;
  selected: boolean;
}
const Correios: React.FC<CorreiosProps> = ({ className, selected, onSelect }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [buttonText, setButtonText] = useState("Selecionar");

  const handleButtonClick = () => {
    onSelect();
    setButtonText("Selecionado");
  };

  return (
    <Box width={310} height={320} padding={1} borderRadius={2} border={selected ? "2px solid #C2272B" : "1px solid #D9D9D9"} bgcolor={"#fff"}>
      <Box display={"flex"} justifyContent={"flex-end"}>
        <Tooltip
          title={
            <>
              <p style={{ fontSize: "14px" }}>
                Dúvidas de como funciona? Acesse nossa{" "}
                <a target="_blank" style={{ color: "#fff", fontWeight: 900 }} href="https://www.cliqueretire.com.br/perguntas-frequentas-faq/">
                  Central de ajuda
                </a>
              </p>
            </>
          }
          arrow
          placement="top">
          <IconButton>
            <IconInformative width={24} height={24} />
          </IconButton>
        </Tooltip>
      </Box>

      <img src={ImgClique} style={{ width: 150, display: "block", margin: "0 auto" }} />
      <Box display={"flex"} flexDirection={"column"} mt={2}>
        <Box marginY={3} marginX={2}>
          <li>Você deverá levar o produto até uma agência dos Correios;</li>
          <li>Assim que aprovado, será enviado um código reverso para o seu e-mail.</li>
        </Box>
        <Button
          onClick={handleButtonClick}
          variant="outlined"
          sx={{ color: selected ? "#C2272B" : "#222020", borderColor: selected ? "#C2272B" : "#222020", width: 150, alignSelf: "center", borderRadius: 100 }}>
          {selected ? "Selecionado" : "Selecionar"}
        </Button>
      </Box>
    </Box>
  );
};
export default Correios;
